import React from 'react';
import styled from 'styled-components';

const PreSaleText = styled.p`
  font-size: 14px;
  padding: 23px 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.grey.light};
`;

export const PreSale = ({ product }) => {
  const { isPreSale, launchingAt } = product || {};

  if (!isPreSale) {
    return null;
  }

  return (
    <PreSaleText>
      <strong>Pré-venda: </strong> lançamento em {launchingAt}
    </PreSaleText>
  );
};

export default PreSale;
